import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { ValueData } from '@/types/project';
import { formatCurrency } from '@/utils/formatters';

interface ValueFormProps {
  value: ValueData;
  onChange: (field: keyof ValueData, value: number | null) => void;
}

export function ValueForm({ value, onChange }: ValueFormProps) {
  const totalValue = (value.contractValue || 0) + 
    (value.approvedVariations || 0) + 
    (value.unapprovedVariations || 0);

  const fields = [
    { id: 'contractValue', label: 'Contract Value' },
    { id: 'approvedVariations', label: 'Approved Variations' },
    { id: 'unapprovedVariations', label: 'Unapproved Variations' },
    { id: 'invoicedToDate', label: 'Invoiced to Date' },
    { id: 'retention', label: 'Retention' },
    { id: 'forecastedRevenue', label: 'Forecasted Value' },
  ] as const;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Value</CardTitle>
        <div className="text-sm text-muted-foreground">
          Total: {formatCurrency(totalValue)}
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {fields.map(({ id, label }) => (
            <div key={id} className="space-y-2">
              <Label htmlFor={id}>{label} (£)</Label>
              <Input
                id={id}
                type="number"
                value={value[id] ?? ''}
                onChange={(e) => onChange(id, e.target.value ? Number(e.target.value) : null)}
                placeholder={`Enter ${label.toLowerCase()}`}
                className="text-right"
              />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}